import classNames from "classnames/dedupe";
import React, { FC, ReactNode } from "react";

import { Column, Row } from "../../Fundamentals/Grid";
import { Image, IImageData } from "../../Utility/MediaBuilder/Image";

export interface IImageContentWidgetProps {
  /**
   * Set aspect ratio for images
   */
  imageRatio?: "16x9" | "5x4" | "4x5";

  /**
   * Position of description text
   */
  textPosition?: "left" | "right";

  /**
   * Data set - array of images
   */
  images?: IImageData[];

  /**
   * Widget title text
   */
  title?: string;
  /**
   * The custom set of css classes used to style component
   */
  classes?: {
    row?: string;
  };

  /**
   * Set widget content (text)
   */
  children?: ReactNode;
  /**
   * Custom media component
   */
  customMedia?: JSX.Element;
}

const ImageContentWidget: FC<IImageContentWidgetProps> = ({
  imageRatio = "16x9",
  images,
  title,
  textPosition,
  classes,
  children,
  customMedia,
}) => {
  const scaleClass = classNames("ratio", "ratio-img", `ratio-${imageRatio}`);
  const rowClass = classNames(classes?.row, {
    "flex-row-reverse": textPosition === "right",
  });
  const rowAlign = title && children ? "align-items-center" : null;
  const imgColSize = images?.length > 2 || title || children ? 6 : null;

  return (
    <Row alignItems={rowAlign} classes={{ root: rowClass }}>
      {children && title && (
        <Column
          xs={12}
          md={6}
          classes={{ root: "mb-7 mb-md-0 pe-md-9 text-color-blue" }}
        >
          <div className="h2-enriched mb-6">{title}</div>
          <p className="p-medium mb-0">{children}</p>
        </Column>
      )}
      {customMedia ??
        images?.map((image) => (
          <Column
            xs={12}
            md={imgColSize}
            classes={{ root: "mb-6" }}
            key={image.src}
          >
            <div className={scaleClass} data-testid="aspect-ratio">
              <Image src={image.src} alt={image.alt} />
            </div>
          </Column>
        ))}
    </Row>
  );
};

export default ImageContentWidget;
